import { render, staticRenderFns } from "./VueFormulateStarRating.vue?vue&type=template&id=50574bd5&"
import script from "./VueFormulateStarRating.vue?vue&type=script&lang=js&"
export * from "./VueFormulateStarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports